module.exports = __webpack_public_path__ + "static/media/ipk2022_Branding.004.eea3ebad.jpeg";